import React from "react";
import MultiSelctCheckboxDropdown from "../../../../components/CheckboxMultiselect";
import { IconButton } from "@mui/material";
import downArrowImg from "../../../../styles/svg/downArrow.svg";
import { useSelector } from "react-redux";
import { CustomButton } from "../../../../components/Button/Button";
import { useListViewColumnFilter } from "./hooks/useListViewColumnFilter";

const MilestoneColumnHeader = () => {
  const milestone = useSelector(
    (state) => state.listViewHeaderFilters.milestoneIds
  );
  const {
    anchorEl,
    handleClearFilter,
    handleClick,
    handleClose,
    handleSelectionChange,
    selectedItems,
  } = useListViewColumnFilter({
    filterKey: "columnMilestone",
    resetKey: "milestone",
    parseSelectedItems: Number,
  });

  return (
    <>
      <CustomButton className="remove-default-button-style reset-btn">
        Milestone
        <IconButton onClick={handleClick}>
          <img src={downArrowImg} alt="arrow" />
        </IconButton>
      </CustomButton>
      <MultiSelctCheckboxDropdown
        items={milestone}
        selectedItems={selectedItems}
        onSelectionChange={handleSelectionChange}
        isButton={true}
        anchorEl={anchorEl}
        valueKey="epic_id"
        displayKey="epic_name"
        handleClose={handleClose}
        handleClearFilter={handleClearFilter}
      />
    </>
  );
};

export default MilestoneColumnHeader;
